const extractFieldsFromNote = (note) => {
    if (!note) return { note: '', companyName: '', floorDoor: '' };

    // Replace <br> with real line breaks first
    const cleanNote = note.replace(/<br\s*\/?>/gi, '\n');

    const lines = cleanNote.split('\n');

    let noteLines = [];
    let companyName = '';
    let floorDoor = '';

    lines.forEach((line) => {
        if (line.startsWith('Company name:')) {
            companyName = line.replace('Company name:', '').trim();
        } else if (line.startsWith('Floor and door:')) {
            floorDoor = line.replace('Floor and door:', '').trim();
        } else {
            // Only add lines to note if we haven't hit "Company name:" yet
            if (!companyName && !floorDoor) {
                noteLines.push(line.trim());
            }
        }
    });

    return {
        note: noteLines.join('\n').trim(),
        companyName,
        floorDoor,
    };
};

export default extractFieldsFromNote;
